export default __webpack_public_path__ + "static/media/BPO.4d3d7ac6.jpg";